<template>
  <div class="profile-page">
    <p class="page-title">最新动态</p> 
    <el-row :gutter="20">
      <el-col :span="24">
        <v-card>
          <el-tabs v-model="currentTab" @tab-click="handleSearch()">
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="公司新闻" name="company"></el-tab-pane>
            <el-tab-pane label="行业新闻" name="industry"></el-tab-pane>
            <el-tab-pane label="媒体关注" name="media"></el-tab-pane>
          </el-tabs>
          <div class="newsListTopBlock"></div>
          <div v-for="item in NewsList" :key="item.id">
          <router-link :to="{name: 'ArticleDetail', params: {id: item.id}}">
            <el-row :gutter="22" class="newsListRow">
              <el-col :span="5">
                <div class="textImgBox">
                  <img :src="`/static/images/${item.articleType}.jpg`" width="200" height="120">
                </div>
              </el-col>
              <el-col :span="16">
                <span class="textTitle">{{item.title}}</span>
                <p class="textEllipsis" v-html="item.body"></p>
                <div class="textFoot">媒体来源：{{item.author}}</div>
              </el-col>
              <el-col :span="3">
                <div class="textDate">
                  <p >{{item.creationTime | date('MM-DD') | NullDate}}</p>
                  <span class="textArrow"><i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </el-col>
            </el-row>
          </router-link>
          </div>
          <el-pagination
            class="text-right"
            @size-change="handleSizeChange"
            @current-change="handleChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </v-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
export default {
  data() {
    return {
      currentTab: 'all',
      NewsList: [],
      IsLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  created() {
    if (this.$route.params.tabs) {
      this.currentTab = this.$route.params.tabs
    }
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.IsLoading = true
      this.$http.get(`${process.env.API_HOST}/Article`, {
        params: {
          ArticleType: this.currentTab,
          index: this.currentPage,
          size: this.pageSize,
        },
      }).then((data) => {
        this.IsLoading = false
        var result = data.data
        this.NewsList = result.list
        this.total = result.total
      }).catch((error) => {
        this.IsLoading = false
        this.$alert(error.message)
      })
    },
    handleChange(params) {
      this.currentPage = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
  },
  computed: {
    routePath() {
      return this.$route.path
    },
  },
  components: {
    vCard,
  },
}
</script>

<style lang="less" scoped>
.profile-page {
  padding-left: 10px;
  padding-right: 10px;
}
.page-title1{font-size: 18px;padding-bottom: 20px;}
.contract {
  margin-top: 20px;
  padding: 30px;
  .row {
    height: 44px;
    font-size: 12px;
    &:last-child {
      margin-top: 20px;
    }
    p {
      margin: 0;
    }
    .fa {
      line-height: 44px;
      font-size: 28px;
      color: #20a0ff;
    }
  }
}

.menu {
  background-color: transparent;
  .menu-item {
    height: 46px;
    line-height: 46px;
    background-color: transparent;
    border-left: 4px solid transparent;
    color: #43484d;
    &.is-active {
      background-color: #e5e9f2;
      border-left: 4px solid #707070;
      color: #43484d;
    }
    .fa {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="less">
.profile-page {
    .newsListTopBlock {
      padding-top: 20px;
    }
    .newsListRow {
      margin-bottom: 20px;
      margin-bottom: 20px;
      padding-bottom: 15px;
      .textImgBox {
        text-align:center;
      }
      .textTitle {
        font-weight: bold;
      }
      .textInfo {
        font-size: 12px;
        color: #999;
      }
      .textEllipsis {
        padding-top: 15px;
        color: #666;
        font-size: 12px;
        line-height:20px;
        height:72px;
        display:-webkit-box !important;
        overflow:hidden;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:3;
      }
      .textFoot {
        margin-top: 10px;
        color: #999;
      }
      .textDate {
        margin:10px 0;
        height:100px;
        border-left: solid 1px #ccc;
        font-size: 24px;
        text-align: center;
        color: #999;
      }
      .textArrow {
        font-size:18px;
        line-height:72px;
      }
    }
  
  .btn {
    background-color: #c8e7fd;
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
  .el-button {
    border:none;
    border-color:#c8e7fd;
  }
  .more1 {
    overflow: hidden;
    line-height: 20px;
    width: 260px;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 20px;
  }
  .more1 {
    i{
      font-size: 5px;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ArticleListPage.vue?4b2ea80e